/// <amd-module name="Pipeline/Analytics/PipelineDurationCommon/LinearRegression" />
import * as CommonTypes from "Analytics/Shared/Common/Types";
import { getPercentageVariation } from "Analytics/Shared/Utils/Number";
import { Point } from "Pipeline/Analytics/PipelineDurationCommon/Types";

export function getTrendAndVariation(dataPoints: Point[]): CommonTypes.ITrendData {
    if (dataPoints && dataPoints.length > 1) {
        const slopeAndIntercept = getSlopeAndIntercept(dataPoints);
        const trendData: CommonTypes.ITrendData = {
            startValue: getLinearRegressionValueForX(slopeAndIntercept, 0),
            endValue: getLinearRegressionValueForX(slopeAndIntercept, 1),
            trendType: CommonTypes.TrendType.Increased,
            percentageVariation: 0
        };
        if (trendData.startValue && trendData.endValue) {
            if (trendData.startValue > trendData.endValue) {
                trendData.trendType = CommonTypes.TrendType.Decreased;
            }
            trendData.percentageVariation = Math.abs(getPercentageVariation(trendData.startValue, trendData.endValue));
            return trendData;
        } else {
            throw new Error("Unable to get the Trend with the data points provided");
        }
    } else {
        throw new Error("Not enough data points to compute trend");
    }
}

function getSlopeAndIntercept(dataPoints: Point[]): SlopeAndIntercept {
    const slopeAndIntercept: SlopeAndIntercept = { intercept: 0, slope: 1 };
    let sumX = 0;
    let sumY = 0;
    let sumXX = 0;
    let sumXY = 0;
    const n = dataPoints.length;
    for (const point of dataPoints) {
        sumX += point.x;
        sumY += point.y;
        sumXX += point.x * point.x;
        sumXY += point.x * point.y;
    }
    if (n * sumXX - sumX * sumX == 0) {
        throw new Error("Error computing slope and intercept with the data points provided");
    }
    // Standard formulas for a linear regression
    slopeAndIntercept.slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX);
    slopeAndIntercept.intercept = (sumY - slopeAndIntercept.slope * sumX) / n;
    return slopeAndIntercept;
}

function getLinearRegressionValueForX(linearRegressionParam: SlopeAndIntercept, x: number): number {
    return linearRegressionParam.slope * x + linearRegressionParam.intercept;
}

interface SlopeAndIntercept {
    intercept: number;
    slope: number;
}
